var React = require('react');

function LawCurve (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Combined Shape"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Background","fill":"#FFFFFF"},React.createElement("path",{"d":"M0.01565,437.942493 C1.07,434.16 57.5,245.07 800,252 C1550,259 1600,0.58 1600,0.58 L1600,0.58 L1600,438 L0,438 Z","id":"Combined-Shape"})))]);
}

LawCurve.defaultProps = {"viewBox":"0 0 1600 438","version":"1.1"};

module.exports = LawCurve;

LawCurve.default = LawCurve;
